import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import atoms from "../../atoms";
import { RxCross2 } from "react-icons/rx";
import "./productFilterStyle.scss";
import { ProductFilterProps } from "./interface";

const { Button } = atoms;
const Index = ({
  show,
  header,
  onHide,
  buttonDisable,
  handleSubmit,
  submitBtnText,
  children,
}: ProductFilterProps) => {
  return (
    <Modal
      className="rounded-0"
      isOpen={show}
      wrapClassName="light-box-modal-right"
    >
      <ModalHeader className="d-flex border-0 position-relative">
        <div className="mt-4 fs-24 fw-600 mb-0">{header ?? "Filter"}</div>
        <div
          className="position-absolute py-1 px-2"
          style={{
            top: "15%",
            right: "3%",
            backgroundColor: "transparent",
            border: "1px solid #222",
            borderRadius: "50%",
            cursor: "pointer",
          }}
          onClick={onHide}
        >
          <RxCross2 style={{ color: "#222" }} />
        </div>
      </ModalHeader>
      <ModalBody className="pt-md-0">
                {children}
      </ModalBody>
        <ModalFooter
          className="border-0 d-flex"
          style={{ flexWrap: "inherit" }}
        >
          <Button
            className="fs-16 fw-500 approve-btn w-100"
            onClick={() => handleSubmit() }>
            {submitBtnText ?? "Apply Filter"}
          </Button>
        </ModalFooter>
    </Modal>
  );
};

export default Index;
